(() => {
  const format = value => new Intl.NumberFormat('sv-SE').format(value).replace(/\s/g, '.');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-renton-counter]:not([data-counter-ready])').forEach(el => {
      const target = Number(el.dataset.rentonCounter);
      if (!Number.isFinite(target) || target < 0) return;
      el.dataset.counterReady = 'true';
      el.textContent = format(target);
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const start = performance.now();
        el.dataset.counterStarted = 'true';
        const tick = now => {
          const progress = Math.min((now - start) / 1100, 1);
          el.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1 && !reduced.matches) requestAnimationFrame(tick);
          else { el.textContent = format(target); el.dataset.counterComplete = 'true'; }
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.6 });
      observer.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
